// MessageForm.jsx
import React, { useState } from 'react';
import { post } from '../../helpers/apiHelper';

const MessageForm = () => {
    const [message, setMessage] = useState({
        receiver: '', content: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        await post('communication/send', message);
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" placeholder="Receptor" onChange={(e) => setMessage({ ...message, receiver: e.target.value })} />
            <button type="submit">Enviar</button>
        </form>
    );
};

export default MessageForm;